<template>
  <div class="flex flex-column gap-1">
    <label>Content Media Type</label>
    <div class="flex gap-3">
      <div
        class="media-type-option flex align-items-center gap-2 px-3 py-2 border-round-3xl cursor-pointer"
        :class="{ 'media-type-option-podcast-active': modelValue === 'podcast' }"
        @click="$emit('update:modelValue', 'podcast')"
      >
        <RadioButton
          :id="`contentMediaTypePodcast${idSuffix}`"
          :modelValue="modelValue"
          value="podcast"
          :name="`contentMediaType${idSuffix}`"
          @update:modelValue="$emit('update:modelValue', $event)"
        />
        <i class="pi pi-microphone media-type-icon-podcast"></i>
        <label :for="`contentMediaTypePodcast${idSuffix}`" class="cursor-pointer"
          >Podcast</label
        >
      </div>
      <div
        class="media-type-option flex align-items-center gap-2 px-3 py-2 border-round-3xl cursor-pointer"
        :class="{ 'media-type-option-snippet-active': modelValue === 'snippet' }"
        @click="$emit('update:modelValue', 'snippet')"
      >
        <RadioButton
          :id="`contentMediaTypeSnippet${idSuffix}`"
          :modelValue="modelValue"
          value="snippet"
          :name="`contentMediaType${idSuffix}`"
          @update:modelValue="$emit('update:modelValue', $event)"
        />
        <i class="pi pi-bolt media-type-icon-snippet"></i>
        <label :for="`contentMediaTypeSnippet${idSuffix}`" class="cursor-pointer"
          >Snippet</label
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import RadioButton from "primevue/radiobutton";

defineProps({
  modelValue: {
    type: String,
    default: "podcast",
  },
  idSuffix: {
    type: [String, Number],
    default: "",
  },
});
defineEmits(["update:modelValue"]);
</script>

<style scoped>
.media-type-option {
  border: 1px solid var(--surface-border);
  transition: all 0.15s ease;
}

.media-type-option:hover {
  border-color: var(--primary-color);
}

.media-type-icon-podcast {
  color: #6366f1;
}

.media-type-icon-snippet {
  color: #f59e0b;
}

.media-type-option-podcast-active {
  border-color: #6366f1;
  background: rgba(99, 102, 241, 0.08);
}

.media-type-option-snippet-active {
  border-color: #f59e0b;
  background: rgba(245, 158, 11, 0.08);
}
</style>
